import { Component, OnInit } from '@angular/core';

import { environment } from './../../../../environments/environment';


@Component({
    selector: 'app-navbar',
    templateUrl: './navbar.component.html',
    styleUrls: ['./navbar.component.scss'],
    standalone: false
})
export class NavbarComponent implements OnInit {

    constructor() { }

    ngOnInit() {
    }

    public officeUrl(): string {
        return environment.officeAppUrl;
    }
}
